
function TeamInvite() {
}

TeamInvite.prototype.acceptInvite = function (teamId, callback)
{
  $.ajax({
    url: '/api/friends/team-invitation/' + teamId + '/accept',
    method: 'post',
    success: function () {
      window.success('Convite aceito com sucesso');
      if (!callback) {
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      } else {
        callback();
      }
    },
    error: function (data) {
      if (data && data.responseJSON && data.responseJSON.message) {
        window.warning(data.responseJSON.message);
      } else {
        window.warning('Falha ao aceitar o convite');
      }
    }
  });
};

TeamInvite.prototype.declineInvite = function (teamId, callback)
{
  $.ajax({
    url: '/api/friends/team-invitation/' + teamId + '/decline',
    method: 'post',
    success: function () {
      window.success('Convite recusado com sucesso');
      if (!callback) {
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      } else {
        callback();
      }
    },
    error: function (data) {
      if (data && data.responseJSON && data.responseJSON.message) {
        window.warning(data.responseJSON.message);
      } else {
        window.warning('Falha ao recusar o convite');
      }
    }
  });
}

var teamInvite = new TeamInvite();